import { useState } from "react";
import { FlowDiagram } from "@/components/mimic/FlowDiagram";
import { UtilitiesBar } from "@/components/mimic/UtilitiesBar";

const OVERLAYS = ["yield", "energy", "safety", "quality"];

export function OverlaySwitcher({ active, onChange }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="overlay-switcher">
      {OVERLAYS.map((o) => (
        <button
          key={o}
          onClick={() => onChange(o)}
          data-testid={`mimic-overlay-${o}`}
          className="text-[10px] font-heading uppercase px-2.5 py-1 rounded-full border transition-colors"
          style={{
            borderColor: active === o ? "var(--oim-green)" : "var(--oim-border)",
            color: active === o ? "var(--oim-green)" : "var(--oim-text-muted)",
            background: active === o ? "rgba(0,200,83,0.08)" : "transparent",
          }}
        >
          {o}
        </button>
      ))}
    </div>
  );
}

export function PlantMimic({ mimic }) {
  const [overlay, setOverlay] = useState("yield");
  if (!mimic) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="mimic-loading">Loading…</div>;

  return (
    <div className="space-y-5" data-testid="plant-mimic">
      <OverlaySwitcher active={overlay} onChange={setOverlay} />
      <div className="space-y-6">
        <FlowDiagram chainKey="benzene" flow={{ ...mimic.benzene, overlay }} />
        <FlowDiagram chainKey="toluene" flow={{ ...mimic.toluene, overlay }} />
        <FlowDiagram chainKey="valorization" flow={{ ...mimic.valorization, overlay }} />
      </div>
      <UtilitiesBar utilities={mimic.utilities} />
      <div className="flex flex-wrap gap-4 text-[10px] text-[var(--oim-text-dim)]" data-testid="mimic-legend">
        <span className="flex items-center gap-1.5"><span className="inline-block w-4 h-0.5" style={{ backgroundColor: "var(--oim-green)" }} /> Process Flow</span>
        <span className="flex items-center gap-1.5"><span className="inline-block w-4 h-0.5 border-t border-dashed" style={{ borderColor: "var(--oim-green)" }} /> Recycle / Recovery</span>
        <span className="flex items-center gap-1.5"><span className="inline-block w-4 h-0.5 border-t border-dashed" style={{ borderColor: "#8B5CF6" }} /> Residue / Waste</span>
      </div>
    </div>
  );
}
